<template>
  <div class="group-detail" v-show="isAccepted">
    <h1 class="common__main-title">Lesson Details and Submission</h1>
    <div>
      <div class="common__sub-title gray">Detail</div>
      <div class="content-wrapper">
        <div class="main-content">
          <div class="detail-table">
            <div>
              <div class="detail__item-title">Booth number</div>
              <p class="detail__item">{{ lesson.booth | booth }}</p>
            </div>
            <div>
              <div class="detail__item-title">Course</div>
              <p class="detail__item">{{ lesson.course && lesson.course.name }}</p>
            </div>
            <div>
              <div class="detail__item-title">University</div>
              <p  class="detail__item">{{ lesson.university && lesson.university.name }}</p>
            </div>
            <div>
              <div class="detail__item-title">Campus</div>
              <p class="detail__item">{{ lesson.campus && lesson.campus.name }}</p>
            </div>
            <div>
              <div class="detail__item-title">Level</div>
              <p class="detail__item">{{ lesson.level && lesson.level.name }}</p>
            </div>
            <div>
              <div class="detail__item-title">Unit</div>
              <p class="detail__item">{{ lesson.unit }}</p>
            </div>
            <div>
              <div class="detail__item-title">Date</div>
              <p class="detail__item">
                {{ lesson.date && lesson.date.format('YYYY/MM/DD') }}
                Period {{ lesson.period }}
              </p>
            </div>
            <div>
              <div class="detail__item-title">Tutor</div>
              <div class="detail__item">
                <div v-if="lesson.teacher" class="tutor-box">
                  <router-link
                    class="tutor-name"
                    :to="{
                      name: 'TutorDetail',
                      params: { id: lesson.teacher.tutor.id }
                    }"
                  >
                    {{ lesson.teacher.tutor.name}}
                  </router-link>
                  <router-link
                    :to="{
                      name: 'TutorDetail',
                      params: { id: lesson.teacher.tutor.id }
                    }"
                    class="tutor-info"
                  >
                    {{ lesson.teacher.tutor.id }} {{ lesson.teacher.tutor.position.name }}
                  </router-link>
                  <div v-if="lesson.teacher.isAbsent" class="absent-info">
                    Absent
                  </div>
                </div>
                <div v-else class="tutor-box">
                  <p class="tutor-name">----------------</p>
                  <p class="tutor-info">--- ---</p>
                </div>
              </div>
            </div>
            <div>
              <div class="detail__item-title">Substitute Tutor</div>
              <div class="detail__item">
                <div class="tutor-box">
                  <template v-if="lesson.substituteTutor">
                    <p class="tutor-name">
                      {{ lesson.substituteTutor.tutor.name }}
                    </p>
                    <p class="tutor-info">
                      {{ lesson.substituteTutor.tutor.id }}
                      {{ lesson.substituteTutor.tutor.position.name }}
                    </p>
                    <p class="substitute-time">
                      Substitute Time : {{ this.substituteTime }}
                    </p>
                  </template>
                  <template v-else>
                    <p class="tutor-name">----------------</p>
                  </template>
                </div>
                <div v-if="!isTutor">
                  <b-button pill variant="primary" size="sm" @click="openSubstituteModal">
                    Select Substitute
                  </b-button>
                  <b-button v-if="lesson.substituteTutor" @click="removeSubstitute"
                    pill variant="danger" size="sm" class="ml-2">
                    Remove Substitute
                  </b-button>
                </div>
              </div>
            </div>
            <div>
              <div class="detail__item-title">Student</div>
              <div class="detail__item">
                <div
                  v-for="student of lesson.students"
                  :key="student.index"
                  class="student"
                >
                  <router-link
                    :to="{
                      name: 'StudentDetail',
                      params: { id: student.student.id }
                    }"
                    class="mr-3"
                  >
                    {{ student.student.name }}
                  </router-link>
                  <div class="grade">WeTEC:{{ student.wetecResult }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common__button-container">
      <b-button
        pill
        variant="secondary"
        @click="$router.go(-1)"
      >
        Back
      </b-button>
    </div>
    <SelectSubstituteModal
      ref="selectSubstituteModal"
      :lesson="lesson"
      @startRegisterSubstitute="onRegisterSubstitute"
    />
    <ErrorModal ref="errorModal" />
    <!-- OK時は画面リロード -->
    <SuccessModal ref="sucessModal" @ok="$router.go(0)"/>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import Vue from 'vue'
import { Lesson } from '@/store/lessons/types'
import { Booth } from '@/store/booths/types'
import SelectSubstituteModal from '@/components/parts/modal/SelectSubstituteModal.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorModal from '@/components/parts/modal/Error.vue';
import { RootState } from '@/store/types';
import Loading from '@/components/parts/modal/Loading.vue'

export default Vue.extend({
  components: {
    SelectSubstituteModal,
    ErrorModal,
    SuccessModal,
    Loading,
  },

  filters: {
    booth(b: Booth|null) {
      if (_.isNull(b)) return null
      return `${b.building} - ${b.room} - ${b.number}`
    },
    substituteTime(time: number|null): string {
      if (time === null) return 'Provisional'
      if (time === 100) return 'All'
      return `${time} min`
    },
  },

  computed: {
    lesson(): any {
      const lesson: Lesson = this.$store.getters.findLessonByScheduleId(this.$route.params.lessonId)
      if (lesson) {
        return lesson
      }
      return {
        scheduleId: null,
        date: null,
        period: null,
        university: null,
        campus: null,
        unit: null,
        course: null,
        level: null,
        booth: null,
        teacher: null,
        substituteTutor: null,
        students: [],
        lessonMinute: null,
      }
    },
    /**
     * アクセス権限チェック
     * @returns {boolean} ture: アクセスOK, false: アクセスNG
     */
    isAccepted(): boolean {
      const { profile } = (this.$store.state as RootState).auth
      if (_.indexOf(['admin', 'senior'], profile?.authority) !== -1) {
        // 管理者、シニアはOK
        return true
      }

      // レッスンの教師か代講チューターであればOK
      return this.lesson.teacher?.tutor.id === profile?.id
        || this.lesson.substituteTutor?.id === profile?.id
    },
    substituteTime(): string {
      const time = _.get(this.lesson, 'substituteTutor.time')
      const lessonMinute = _.get(this.lesson, 'lessonMinute')
      if (time === null) {
        return 'Provisional'
      }
      if (time === lessonMinute) {
        return 'All'
      }

      return `${time} min`
    },
    isTutor(): boolean {
      return (this.$store.state as RootState).auth.profile?.authority === 'tutor'
    },
  },

  data: (): {
    isLoading: boolean,
  } => ({
    isLoading: false,
  }),

  async created() {
    try {
      // レッスン情報取得
      this.isLoading = true
      await this.$store.dispatch('getLessonByScheduleId', {
        scheduleId: this.$route.params.lessonId,
      })
      this.isLoading = false
    } catch (error: any) {
      this.$bvModal.msgBoxOk(error.message)
      this.isLoading = false
    }

    // アクセス権限チェック
    if (!this.isAccepted) {
      this.$router.push({ name: 'Home' })
    }
  },

  methods: {
    // 代講チューター選択モーダル表示
    openSubstituteModal() {
      if (this.lesson.fiscalYear <= 2023) {
        this.$bvModal.msgBoxOk('Error - This data from 2021 to 2023 cannot be registered.');
        return;
      }
      (this.$refs.selectSubstituteModal as any).open(this.lesson.substituteTutor);
    },
    /**
     * 代講チューター登録開始
     * @param {Promise} promise 代講チューター登録promise
     */
    onRegisterSubstitute(promise: Promise<any>) {
      promise
        .then(() => {
          (this.$refs.sucessModal as SuccessModal).open();
        })
        .catch((error: Error) => {
          let message = _.get(error, '.response.data.message')
          switch (_.get(error, 'response.data.code')) {
            case 409001:
              message = 'Selected tutor is already assign another schedule.';
              break;
            default:
          }
          (this.$refs.errorModal as ErrorModal).open(message);
        })
        .finally(() => {
          (this.$refs.selectSubstituteModal as any).close();
        });
    },
    /**
     * 代講チューターの削除
     */
    async removeSubstitute() {
      if (await this.$bvModal.msgBoxConfirm('Remove substitute tutor?')) {
        await this.$store.dispatch('removeSubstitute', { scheduleId: this.$route.params.lessonId })
        await this.$bvModal.msgBoxOk('Success !')
        this.$router.go(0)
      }
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
  margin-bottom:20px;
}

.main-content {
  background: #fff;
  padding: 30px 60px;
  border-radius: 20px;
  margin-bottom:20px;
}

.detail-table {
  width:100%;
}

.detail__item-title {
  line-height: 14px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  margin-bottom:10px;
}

.detail__item-title::before {
  content: '●';
  color: #F8CBAD;
  margin-right: 5px;
  vertical-align: text-top;
}

.detail__item {
  line-height: 14px;
  font-size: 14px;
  margin-bottom:30px;
  padding-left:20px;
}

.student {
  margin-bottom:10px;
  align-items: center;
  display: flex;
}

.tutor-box {
  display: flex;
  align-items: center;
}

.grade {
  padding: 5px 10px ;
  background: #FFD966;
  border-radius: 30px;
  cursor: pointer;
  text-decoration: none;
}

.tutor-name {
  display: flex;
  align-items: center;
  margin-right:20px;
}

.tutor-info {
  margin-right:10px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 5px 10px ;
  background: #638ACF;
  color: #fff;
  border-radius: 30px;
  text-decoration: none;
  border: 2px solid #638ACF;
}

.tutor-info:hover {
  background: #fff;
  color: #638ACF;
  cursor: pointer;
}

.absent-info {
  margin-right:10px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 5px 10px ;
  color: #fff;
  border-radius: 30px;
  text-decoration: none;
  background: #A5A5A5;
  border:2px solid #A5A5A5;
}

.substitute-time {
  margin-right:10px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 5px 10px ;
  background: #F38181;
  color: #fff;
  border-radius: 30px;
  text-decoration: none;
}

</style>
